/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

require('prismjs/plugins/line-numbers/prism-line-numbers.css');
require('highcharts/css/highcharts.css');

require('./src/styles/js/ids-core.js');
require('./src/styles/css/a11y-dark.css');
require('./src/styles/stylus/styles.styl');
// require('../stylus/relax-dark.styl');
// require('../stylus/solAArized-dark.css');

// Add client-side code here
export const onClientEntry = () => {
  if (typeof window !== 'undefined') {
    // Fetch latest V17 version info and continuesly try to update the link to the bundle
    // As the page with the bundle versions and links is auto-generated from markdown files
    // There is no reliable way to execute client-side JavaScript there
    // So we fetch the latest info and just try to update the link every 1 second everywhere on the site 🤷‍♂️
    fetch(
      'https://feeds.dev.azure.com/if-public/56f785fd-3cf9-4478-9974-934e34a2645b/_apis/packaging/Feeds/IfDesignSystem/Packages?includeAllVersions=true&packageNameQuery=@ids-core/bundle&protocol​Type=nuget'
    )
      .then(response => response.json())
      .then(json => {
        const { normalizedVersion, publishDate } = json.value[0].versions.filter(
          version => version.normalizedVersion.includes('17') && !version.normalizedVersion.includes('alpha')
        )[0];
        const latestV17VersionLink = `https://static.design.if.eu/ids-core/${normalizedVersion}/ifdesignsystem.min.css`;

        console.log(
          'latest V17 version',
          normalizedVersion,
          'puglishet at:',
          publishDate,
          'link:',
          latestV17VersionLink
        );

        setInterval(() => {
          const latestV17VersionElement = document.getElementById('latest-v17-version');
          const latestV17VersionDateElement = document.getElementById('latest-v17-publish-date');
          const latestV17VersionLinkElement = document.getElementById('latest-v17-link');

          if (latestV17VersionLinkElement) {
            latestV17VersionLinkElement.innerHTML = latestV17VersionLink;
            latestV17VersionLinkElement.href = latestV17VersionLink;
          }

          if (latestV17VersionDateElement) {
            latestV17VersionDateElement.innerHTML = new Date(publishDate).toLocaleDateString();
          }

          if (latestV17VersionElement) {
            latestV17VersionElement.innerHTML = normalizedVersion;
          }
        }, 1000);
      });
  }
};
